import styled, { css } from "styled-components";
import { Button } from "../Button";

export const Pagination = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 11px 24px 16px;
    height: 67px;
    width: 100%;
`;

export const PaginationNumbersWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 2px;
`;

export const BasePaginationSizing = css`
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    font-size: 1em;
    width: 40px;
`;

export const PaginationItem = styled(Button)<{ active?: boolean }>`
    transition: 150ms ease-in-out;
    transition-property: background-color, color;
    color: ${({ theme }) => theme.v2.colors["text-primary-700"]};
    background: ${({ theme, active }) => active && theme.v2.colors["primary-50"]};
    border-radius: 8px;
    min-width: 40px;
    max-width: 60px;
    height: 40px;
`;

export const PaginationControl = styled(Button)<{ active?: boolean }>`
    transition: 150ms ease-in-out;
    transition-property: background-color, color;
    color: ${({ theme }) => theme.v2.colors["text-primary-900"]};
    visibility: ${({ disabled }) => (disabled ? "hidden" : "visible")};
`;

export const PaginationEllipsis = styled.div`
    ${BasePaginationSizing}
`;

export const Buffer = styled.div`
    width: 115px;
`;
